import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV120({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.2.0" date="3rd June 2025" title="Big Feature Update!">
      <p className="text-gray-300 mb-4">We're on a roll! We're loving the community's feedback, it really spurs us on! This release brings lots of new exciting features.</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Users can change their display name', '/v1.2.0/changeDisplayName.png')}
        {createClickableListItem('New game photo album', '/v1.2.0/gamePhotoAlubm.png')}
        {createClickableListItem('New photo capture during games', '/v1.2.0/photoGallery.jpg')}
        {createClickableListItem('Capture and display game winner photo', '/v1.2.0/winner.jpg')}
        {createClickableListItem('New blind structure overhaul to add breaks', '/v1.2.0/breaks.jpg')}
        {createClickableListItem('Improved in-game menu options', '/v1.2.0/ingamemenu.jpg')}
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.2.0/changeDisplayName.png', 'Change display name feature preview')}
          {createThumbnail('/v1.2.0/gamePhotoAlubm.png', 'Game photo album feature preview')}
          {createThumbnail('/v1.2.0/photoGallery.jpg', 'Photo capture during games feature preview')}
          {createThumbnail('/v1.2.0/winner.jpg', 'Game winner photo feature preview', 'The cat that got the cream!')}
          {createThumbnail('/v1.2.0/breaks.jpg', 'New blind structure overhaul to add breaks feature preview')}
          {createThumbnail('/v1.2.0/ingamemenu.jpg', 'In-game menu options feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">Thanks for the positive feedback, keep it coming!</p>
    </ReleaseCard>
  );
}
